<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="container">
        <div class="row">
          <div class="col-12 mb-5">
            <h1>Welcome, {{ getUserData.firstName }}</h1>
            <h4 class="color-grey">{{ getOrganisationData.name }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="panel content-panel panel-tile">
              <h4>Users</h4>
              <div class="color-blue panel-number">
                {{ totalUsers }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="panel content-panel panel-tile">
              <h4>Completed tests</h4>
              <div class="color-green panel-number">
                {{ totalTestsCompleted }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="panel content-panel panel-tile">
              <h4>Credits remaining</h4>
              <div class="panel-number">
                {{ getOrganisationData.totalCredits }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="panel content-panel panel-tile">
              <h4>Quick links</h4>
              <router-link to="profile"
                ><font-awesome-icon :icon="['fas', 'pen']" /> My
                profile</router-link
              >
              <router-link to="knowledgebase"
                ><font-awesome-icon :icon="['fas', 'book']" /> Knowledge
                base</router-link
              >
            </div>
          </div>
        </div>
        <div class="row py-3 mb-3">
          <div class="col-md-8">
            <h2>Groups</h2>
          </div>
          <div class="col-md-4 text-md-right">
            <router-link to="/group" class="btn btn-primary"
              ><font-awesome-icon icon="plus" /> New Group</router-link
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-if="getGroupsData.length">
            <GroupPanel
              v-bind:key="group.id"
              v-for="group in getGroupsData"
              :groupData="group"
              :link="true"
            />
          </div>
          <div class="col-12">
            <div
              v-if="!getGroupsData.length"
              class="panel panel-flat text-center"
            >
              <h1>No groups created</h1>
              <p>
                Create a first group to get started.
                <router-link to="/group"
                  >Click here to create a group</router-link
                >.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import GroupPanel from "@/components/GroupPanel.vue";
import firebase from "firebase/app";
import "firebase/functions";
export default {
  name: "dashboard",
  components: { GroupPanel },
  data() {
    return {};
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["organisationData"]),
    ...mapState(["groupsData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getGroupsData() {
      return this.groupsData ? this.groupsData : "";
    },
    getOrganisationData() {
      return this.organisationData ? this.organisationData : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    totalTestsCompleted() {
      let total = 0;
      if (this.getGroupsData) {
        this.getGroupsData.forEach((group) => {
          if (group.users) {
            group.users.forEach((user) => {
              if (user.completedInsights) {
                total++;
              }
              if (user.completedPathways) {
                total++;
              }
            });
          }
        });
      }
      return total;
    },

    totalUsers() {
      let total = 0;
      if (this.getGroupsData) {
        this.getGroupsData.forEach((group) => {
          if (group.users) {
            group.users.forEach(() => {
              total++;
            });
          }
        });
      }
      return total;
    },
  },
  mounted() {
    if (this.getUserData && !this.getUserData.updatedDetails) {
      this.$router.push({
        path: "/profile",
      });
    }

    this.axios
      .get("https://portal.aaafc.com.au/wp-json/budget/v1/update/1", {
        params: {
          uid: "wiIS2RO9DakajhYw9InE3IjR1swoxEnP",
          weeklySpend: 52196,
          spenderProfile: "Big Spender",
        },
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {},
};
</script>
